export default __webpack_public_path__ + "static/media/GAN1.a5d75e69.png";